import React from "react";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { color } from "../../mui-theme/palette";

export const IOSSwitch = styled((props: SwitchProps & { loading?: boolean }) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, loading }) => ({
  width: 42,
  height: 26,
  padding: 0,
  display: "flex",
  position: "relative",
  "&:active .MuiSwitch-thumb": {
    width: 22,
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: color.majorRed,
        opacity: 1,
        border: 0,
      },
    },
    ...(loading && {
      opacity: 0.7,
      pointerEvents: "none",
    }),
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 22,
    height: 22,
    borderRadius: 11,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
    position: "relative",
    ...(loading && {
      opacity: 0.8,
      "&::after": {
        content: '""',
        position: "absolute",
        left: "50%",
        top: "50%",
        width: 16,
        height: 16,
        marginLeft: -8,
        marginTop: -8,
        border: "2px solid #999",
        borderTop: "2px solid transparent",
        borderRadius: "50%",
        animation: "mui-spin 0.8s linear infinite",
        zIndex: 2,
      },
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    opacity: 1,
    backgroundColor: loading ? color.greyba : theme.palette.mode === "dark" ? "#39393D" : "#E9E9EA",
    boxSizing: "border-box",
    ...(loading && {
      opacity: 0.8,
    }),
  },
  "@keyframes mui-spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));
